import {
  Avatar,
  Box,
  Button,
  IconButton,
  Popover,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../../assets/logo.png"
import {
  AddShoppingCart,
  FavoriteBorder,
  Storefront,
} from "@mui/icons-material";
import { CategorySheet } from "./CategorySheet";
import { mainCategory } from "../data/mainCategory";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../State/Store";
import { fetchUserProfile} from "../../State/AuthSlice";
import { fetchSellerProfile } from "../../State/seller/sellerSlice";
import { Category } from "../../types/productType";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { getProductsByCategoryId } from "../../State/customer/ProductSlice";

//create component faster by rafc
export const Navbar = () => {
  // need to be speific shouldn't load the whole store advoid for unwanted behaviour

  const auth = useAppSelector((store) => store.auth);
  const seller = useAppSelector((store) => store.seller);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  // museMediaQuery will support to recognize if the screen size is different
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const [selectedCategory, setSelectedCategory] = useState("men");
  const [showCategory, setShowCategory] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleCategoryClick = (categoryId: string, categories: Category[]) => {
    setShowCategory(!showCategory);
    setSelectedCategory(categoryId);
    let name = categories.filter((c) => c.categoryId === categoryId);
    return name;
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const isLoggedIn = auth.isLoggedIn || !!seller.profile; // 1 nơi quyết định login
  const isSeller = auth.roles?.includes("ROLE_SELLER") || !!seller.profile;
  const isAdmin = auth.user?.role === "ROLE_ADMIN" || auth.roles?.includes("ROLE_ADMIN"); // <-- safe on null/undefined
  // useEffect(() => {
  //   if (auth.isLoggedIn) {
  //     dispatch(fetchUserProfile());
  //   }
  // }, [auth.isLoggedIn, dispatch]); // ✅ Runs whenever login state updates
  // // dispatch

  useEffect(() => {
    if (!auth.isLoggedIn) return;
    if (!auth.roles || auth.roles.length === 0) return;
  
    if (auth.roles.includes('ROLE_ADMIN')) {
      // Admin: don't call seller/customer profile fetches
      
      dispatch(fetchUserProfile());
      return;
    }
  
    if (auth.roles.includes('ROLE_SELLER')) {
     
      dispatch(fetchSellerProfile());
      return;
    }
  
    if (auth.roles.includes('ROLE_CUSTOMER')) {
      dispatch(fetchUserProfile());
    }
  }, [auth.isLoggedIn, auth.roles, dispatch]);
  
 
const handleNavigate = () => {
  if (!isLoggedIn) {
    navigate("/login");
    return;
  }

  if (isAdmin) {
    navigate("/admin");
  } else if (isSeller) {
    navigate("/seller");
  } else {
    navigate("/account/orders");
  }
};
const handleGetProductByCategory = async(categoryId:string,pageNumber:number) => { 
  await dispatch(getProductsByCategoryId({categoryId,pageNumber}))
  navigate(`/products/${categoryId}?page=${pageNumber}`)
 }

  return (
    <>
      <Box className="sticky  top-0 left-0 right-0 bg-white" sx={{ zIndex: 2 }}>
        <div className="flex justify-between items-center px-2 lg:px-20  border-b h-[7vh]">
          <div className="flex items-center ">
            <div className="flex items-center gap-1 md:gap-2">
              {/* Mobile */}
              {!isLarge && (
                <div>
                  <IconButton onClick={handleMenuClick}>
                    <MenuIcon sx={{ fontSize: isLarge ? 29 : 20,padding:"0" }} />
                  </IconButton>

                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleMenuClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    style={{ width: "100vw" }}
                  >
                    <div  style={{ padding: 2, position: "relative"}}>
                      <ul    className="flex flex-col w-screen py-[2rem] items-center  font-medium text-gray-800">
                        {mainCategory.map((item, index) => (
                          <li
                          
                            key={index}
                            className="  relative flex-col text-center min-h-[50px]  px-4"
                          >
                            
                            <button
                           
                              className="hover:text-primary hover:border-b-2 cursor-pointer border-primary mainCategory "
                              onClick={() => {
                               
                                if (selectedCategory === item.categoryId) {
                                  setShowCategory(!showCategory);
                                } else if (showCategory == false) {
                                  setShowCategory(true);
                                  setSelectedCategory(item.categoryId);
                                } else {
                                  setShowCategory(true);
                                  setSelectedCategory(item.categoryId);
                                }
                              }}
                            >
                              <button onClick={() => {handleGetProductByCategory(item.categoryId,0)}}> {item.name}</button>
                             
                              {selectedCategory === item.categoryId ? (
                                <ExpandMoreIcon fontSize="small" />
                              ) : (
                                <ChevronRightIcon fontSize="small" />
                              )}
                            </button>

                            {showCategory &&
                              selectedCategory === item.categoryId && (
                                <div className="w-full">
                                  <CategorySheet
                                    selectedCategory={selectedCategory}
                                    showCategory={showCategory}
                                    setShowCategory={setShowCategory}
                                    setAnchorEl={setAnchorEl}
                                  />
                                </div>
                              )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </Popover>
                </div>
              )}
              {/* using bracket can provide our own style including custom color ex text-[2rem] */}
              {isLarge?(<img src={logo} onClick={() => navigate("/")} className="w-full h-[5vh] cursor-pointer" alt="" />):( <h1
                onClick={() => navigate("/")}
                className="logo cursor-pointer text-sm lg:text-2xl text-primary-color"
              >
                VendorVersify
              </h1>)}
             
            </div>
            {/* Desktop */}
            {isLarge && (
              <ul className="flex cursor-pointer items-center font-medium text-gray-800 h-full border-none py-0">
                {mainCategory.map((item, index) => (
                  <li
                    key={index}
                    onMouseEnter={() => {
                      setShowCategory(true);
                      setSelectedCategory(item.categoryId);
                    }}
                    onMouseLeave={() => {
                      setShowCategory(false);
                    }}
                    className="mainCategory z-50  hover:text-primary hover:border-b-2 h-[70px] px-4 border-primary flex items-center"
                  >
                   <button onClick={() => {handleGetProductByCategory(item.categoryId,0)}}> {item.name}</button>
                  
                  </li>
                ))}
                
              </ul>
            )}
             {showCategory && isLarge && (
          <div
            onMouseEnter={() => {
              setShowCategory(true);
            }}
            onMouseLeave={() => {
              setShowCategory(false);
            }}
            
            className="categorySheet absolute top-[4.15rem]  left-20 right-20 border bg-slate-500"
          >
            <CategorySheet
              selectedCategory={selectedCategory}
              showCategory={showCategory}
              setShowCategory={setShowCategory}
              setAnchorEl={setAnchorEl}
            />
          </div>
        )}
          </div>
          <div className="flex gap-1 lg:gap-6 items-center">
            {/* <IconButton>
              <SearchIcon />
            </IconButton> */}

            {/* !!seller.profile converts seller.profile to a strict boolean:
If seller.profile exists (truthy), it disables the button (true).
If seller.profile does not exist (falsy), the button remains clickable (false). */}
            {isLoggedIn ? (
              <Button
                onClick={handleNavigate}
                className="flex items-center gap-2"
              >
                <Avatar
                  sx={{ width: 29, height: 29 }}
                  src="https://cdn.pixabay.com/photo/2020/04/18/14/01/blue-5059268_960_720.jpg"
                />
                <h1 className="font-semibold hidden lg:block">
                  {auth.user?.fullName || seller.profile?.sellerName}
                </h1>
              </Button>
            ) : (
              (isLarge?(<Button
                onClick={() => {
                  navigate("/login");
                }}
                variant="contained"
                
              >
                Login
              </Button>):(<IconButton sx={{ padding:"0 0 0 2px" }}  onClick={() => {
                  navigate("/login");
                }}>
                <AccountCircleIcon sx={{ fontSize: isLarge ? 29 : 20,padding:"0" }}/>
              </IconButton>))
            )}

            {!seller.profile && (
              <>
                <IconButton
                
                  onClick={() => {
                    navigate("/wishlist");
                  }}
                  
                  sx={{ padding:"0 0 0 2px" }} 
                >
                  <FavoriteBorder sx={{ fontSize: isLarge ? 29 : 20 }}  className="text-gray-700" />
                </IconButton>

                <IconButton
                  onClick={() => navigate("/cart")}
                  sx={{ padding:"0 0 0 2px" }} 
                >
                  <AddShoppingCart sx={{ fontSize: isLarge ? 29 : 20 }} className="text-gray-700" />
                </IconButton>
              </>
            )}

            {!auth.isLoggedIn &&
              (seller.profile === null || seller.profile === undefined) && (
                (isLarge?(<Button
                  onClick={() => navigate("/become-seller")}
                  startIcon={<Storefront />}
                  variant="outlined"

                >
                  Become Seller
                </Button>):(<IconButton
                sx={{ padding:"0 0 0 2px" }} 
                
                  onClick={() => navigate("/become-seller")}
                >
                  <Storefront sx={{ fontSize: isLarge ? 29 : 20 }}  />
                </IconButton>))
              )}
       
          </div>
        </div>
      </Box>
    </>
  );
};
